"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PickerToolbar = _interopRequireDefault(require("@material-ui/pickers/_shared/PickerToolbar"));
var _ToolbarButton = _interopRequireDefault(require("@material-ui/pickers/_shared/ToolbarButton"));
var _core = require("@material-ui/core");
var _format = _interopRequireDefault(require("date-fns/format"));
var _he = _interopRequireDefault(require("date-fns/locale/he"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var useStyles = exports.useStyles = (0, _core.makeStyles)({
  toolbar: {
    alignItems: 'flex-start',
    display: 'flex',
    flexFlow: 'row-reverse nowrap'
  }
});
var CustomToolbar = function CustomToolbar(props) {
  var date = props.date,
    isLandscape = props.isLandscape,
    openView = props.openView,
    setOpenView = props.setOpenView,
    title = props.title;
  var handleChangeViewClick = function handleChangeViewClick(view) {
    return function () {
      setOpenView(view);
    };
  };
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_PickerToolbar.default, {
    className: classes.toolbar,
    title: title,
    isLandscape: isLandscape
  }, /*#__PURE__*/_react.default.createElement(_ToolbarButton.default, {
    onClick: handleChangeViewClick('date'),
    variant: "h4",
    selected: openView === 'date',
    label: (0, _format.default)(date, 'dd', {
      locale: _he.default
    })
  }), /*#__PURE__*/_react.default.createElement(_ToolbarButton.default, {
    onClick: handleChangeViewClick('month'),
    variant: "h4",
    selected: openView === 'month',
    label: (0, _format.default)(date, 'MMMM', {
      locale: _he.default
    })
  }), /*#__PURE__*/_react.default.createElement(_ToolbarButton.default, {
    onClick: handleChangeViewClick('year'),
    variant: "h6",
    label: (0, _format.default)(date, 'yyyy', {
      locale: _he.default
    }),
    selected: openView === 'year'
  }));
};
CustomToolbar.propTypes = {
  date: _propTypes.default.string,
  isLandscape: _propTypes.default.bool,
  openView: _propTypes.default.string,
  setOpenView: _propTypes.default.func,
  title: _propTypes.default.string
};
var _default = exports.default = CustomToolbar;